import { useState } from "react";
import { CalendarDays, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const FamilyAgendaBox = () => {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/courses/agenda/request", { email, website });
      setSent(true);
      toast.success("Si cet e-mail correspond à une inscription, le lien arrive dans ta boîte.");
    } catch (err) { toast.error(apiError(err, "Envoi impossible")); } finally { setBusy(false); }
  };

  return (
    <div className="glass rounded-2xl p-5 sm:p-6 grid md:grid-cols-[1fr_auto] gap-5 items-center" data-testid="family-agenda-box">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-1 flex items-center gap-2"><CalendarDays className="w-3.5 h-3.5" /> Mon agenda famille</div>
        <h3 className="font-display text-2xl leading-none">Tout le planning de l'année, en un clic.</h3>
        <p className="text-xs text-[color:var(--text-muted)] mt-1">Famille inscrite ? Reçois ton lien personnel : toutes les séances de tes enfants dans Google Agenda, Apple Calendar ou Outlook. Le lien est aussi dans tes e-mails de confirmation.</p>
      </div>
      {sent
        ? <div className="text-sm text-[color:var(--accent)]" data-testid="family-agenda-sent">Lien envoyé si l'e-mail est connu. Pense à vérifier tes spams.</div>
        : (
          <form onSubmit={submit} className="flex gap-2 w-full md:w-auto">
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="email@famille.fr" data-testid="family-agenda-email" className="flex-1 md:w-64 bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-full px-4 py-2.5 text-sm focus:outline-none focus:border-[color:var(--accent)]" />
            <input type="text" name="website" tabIndex={-1} autoComplete="off" value={website} onChange={e => setWebsite(e.target.value)} className="hidden" aria-hidden="true" />
            <button disabled={busy} data-testid="family-agenda-submit" className="inline-flex items-center gap-2 bg-[color:var(--accent)] text-black font-semibold px-5 py-2.5 rounded-full text-[10px] uppercase tracking-widest hover:brightness-110 transition disabled:opacity-50">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} Recevoir</button>
          </form>
        )}
    </div>
  );
};
